<template>
  <section class="p-3 w-full space-y-5">
    <div class="flex items-center">
      <label for="language" class="font-bold w-[9rem]"
        >Хэл:<span class="text-red-500">*</span></label
      >
      <select
        name="language"
        id="language"
        class="border rounded p-2 w-full"
        v-model="language"
      >
        <option value="mn">Монгол</option>
        <option value="en">Англи</option>
      </select>
    </div>

    <div class="flex">
      <h4 class="w-[9rem] font-bold">
        Постер зураг:<span class="text-red-500">*</span>
      </h4>

      <div class="w-full">
        <div v-if="selectedImages.length > 0" class="flex gap-4 flex-wrap">
          <div
            v-for="(img, idx) in selectedImages"
            :key="idx"
            class="w-32 overflow-hidden"
          >
            <img :src="img" alt="Selected Image" class="w-32 object-fit" />
          </div>
        </div>

        <div v-else class="flex justify-center items-center h-[30vh]">
          Сонгосон зураг байхгүй байна.
        </div>

        <input
          id="poster"
          name="poster"
          type="file"
          class="w-full border rounded p-2 mt-3"
          @change="onImageChange"
          accept="image/jpeg, image/png"
          multiple
        />
        <p class="text-xs text-sky-500 text-xs italic mt-1 mb-3">
          jpg, jpeg, png өргөтгөлтэй зураг оруулах боломжтой.
        </p>

        <div class="flex gap-4 mb-3">
          <img
            v-for="(img, idx) in previousImages"
            :key="idx"
            :src="img"
            @click="selectPreviousImage(img)"
            class="w-16 h-16 cursor-pointer border rounded hover:ring-2 hover:ring-blue-400"
            :class="{
              'ring-2 ring-blue-500': selectedImages.includes(img),
            }"
            alt="Previous Image"
          />
        </div>
      </div>
    </div>

    <div class="flex items-center">
      <label for="title" class="font-bold w-[9rem]"
        >Файлын нэр<span class="text-red-500">*</span></label
      >
      <input
        type="text"
        id="title"
        name="title"
        class="border rounded p-2 w-full"
        placeholder="Файлын нэр"
        v-model="title"
      />
    </div>

    <div class="flex items-center">
      <label for="pdf" class="font-bold w-[9rem]"
        >Файл<span class="text-red-500">*</span></label
      >
      <div class="w-full">
        <input
          id="pdf"
          name="pdf"
          type="file"
          class="border rounded p-2 w-full"
          accept="application/pdf"
          @change="handleFileUpload"
        />
        <span class="text-sky-500 text-xs">
          Зөвхөн pdf өргөтгөлтэй файл оруулна уу.
        </span>

        <div v-if="previousPdf" class="mt-3 text-sm">
          <button
            @click="selectPreviousPdf(previousPdf)"
            :class="
              pdf === previousPdf
                ? 'text-sky-500'
                : 'text-gray-300 hover:text-sky-500'
            "
          >
            Одоогийн PDF:
            {{ previousPdf }}
          </button>
        </div>
      </div>
    </div>

    <div class="flex bg-gray-200 gap-5 p-3 text-xs text-white">
      <button
        @click="updateSusMining()"
        class="p-2 bg-[#28a745] hover:bg-[#208537]"
      >
        <font-awesome-icon
          :icon="id ? 'fa-solid fa-pen' : 'fa-solid fa-add'"
          class="mr-1"
        />
        {{ id ? "Засах" : "Нэмэх" }}
      </button>

      <button @click="resetForm" class="p-2 bg-orange-400 hover:bg-orange-500">
        <font-awesome-icon icon="fa-solid fa-eraser" class="mr-1" />Арилгах
      </button>
    </div>
  </section>

  <ErrorModal v-if="error" :error="error" />
</template>

<script>
import adminInstance from "@/lib/adminInstance";
import { onMounted, ref } from "vue";
import ErrorModal from "@/components/ui/ErrorModal.vue";

export default {
  name: "YellowEditSustainable",
  props: {
    document: Object,
  },
  components: {
    ErrorModal,
  },
  emits: ["fetchSustainableMining"],
  setup(props, { emit }) {
    const id = ref(null);
    const pdf = ref(null);
    const title = ref(null);
    const language = ref("mn");
    const selectedImages = ref([]);
    const previousImages = ref([]);
    const previousPdf = ref(null);

    const error = ref(null);

    const onImageChange = (event) => {
      const files = Array.from(event.target.files);
      const filePreviews = files.map((file) => URL.createObjectURL(file));
      selectedImages.value.push(...filePreviews);
    };

    const selectPreviousImage = (url) => {
      const index = selectedImages.value.indexOf(url);
      if (index !== -1) {
        selectedImages.value.splice(index, 1);
      } else {
        selectedImages.value.push(url);
      }
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file && file.type === "application/pdf") {
        pdf.value = file;
      } else {
        alert("Зөвхөн PDF файл сонгоно уу.");
        pdf.value = null;
      }
    };

    const selectPreviousPdf = (url) => {
      pdf.value = url;
    };

    const resetForm = () => {
      id.value = null;
      selectedImages.value = [];
      title.value = null;
      language.value = "mn";
      pdf.value = null;
      previousImages.value = null;
      previousPdf.value = null;
    };

    onMounted(() => {
      if (props.document) {
        id.value = props.document.id;
        previousImages.value = props.document.posters || [];
        selectedImages.value = [...previousImages.value];
        title.value = props.document.title;
        language.value = props.document.language;
        previousPdf.value = props.document.pdf;
        pdf.value = props.document.pdf;
      }
    });

    const updateSusMining = async () => {
      const formData = new FormData();

      const inputFiles = document.getElementById("poster").files;
      const filesArray = Array.from(inputFiles);

      const imageOrder = [];

      selectedImages.value.forEach((img, index) => {
        if (img.startsWith("blob:")) {
          const file = filesArray.shift();
          if (file) {
            formData.append("images", file);
            imageOrder.push({ type: "file", index });
          }
        } else {
          imageOrder.push({ type: "url", url: img, index });
        }
      });

      formData.append("imageOrder", JSON.stringify(imageOrder));
      formData.append("title", title.value);
      formData.append("language", language.value);
      formData.append("pdf", pdf.value ? pdf.value : previousPdf.value);
      if (id.value) formData.append("id", id.value);

      try {
        const res = await adminInstance.post(
          id.value
            ? "/update/sustainable-mining"
            : "/insert/sustainable-mining",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (res.status === 200) {
          resetForm();
          emit("fetchSustainableMining");
        }
      } catch (err) {
        error.value = "Алдаа гарлаа";
        setTimeout(() => {
          error.value = null;
        }, 3000);
      }
    };

    return {
      handleFileUpload,
      onImageChange,
      id,
      title,
      language,
      pdf,
      selectedImages,
      resetForm,
      updateSusMining,
      selectPreviousImage,
      previousPdf,
      previousImages,
      selectPreviousPdf,
      error,
    };
  },
};
</script>
